import Backbone from 'backbone';

import i18n from './utils/i18n';
import RouterPages from './router-pages';
import RouterLogs from './router-logs';
import iconLoader from '../shared/utils/iconLoader';

i18n.init();

iconLoader(document.body.getAttribute('data-svg-sprite'));

export default {
	routers: {
		pages: new RouterPages(),
		logs: new RouterLogs()
	},

	start: function() {
		Backbone.history.start({
			pushState: true,
			hashChange: false,
			root: '/extranet'
		});
	}
};
